import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  key: 0,
  class: "image-container"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 2,
  class: "image-container"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 6,
  class: "image-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logos = _resolveComponent("Logos")!
  const _component_CountdownTimer = _resolveComponent("CountdownTimer")!
  const _component_ImageURI = _resolveComponent("ImageURI")!
  const _component_DisplayFields = _resolveComponent("DisplayFields")!
  const _component_Inputs = _resolveComponent("Inputs")!
  const _component_Buttons = _resolveComponent("Buttons")!
  const _component_FooterLogos = _resolveComponent("FooterLogos")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.template.headerLogoURIs)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(_component_Logos, {
            logos: _ctx.template.headerLogoURIs
          }, null, 8, ["logos"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h2", {
      class: "textFormat",
      style: _normalizeStyle({ color: _ctx.setTitleColor }),
      innerHTML: _ctx.formatText(_ctx.template.title)
    }, null, 12, _hoisted_3),
    (_ctx.isJavascriptCountDown())
      ? (_openBlock(), _createBlock(_component_CountdownTimer, {
          key: 1,
          time: _ctx.extractTime()
        }, null, 8, ["time"]))
      : (_ctx.template.imageURI)
        ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
            _createVNode(_component_ImageURI, {
              uri: _ctx.template.imageURI
            }, null, 8, ["uri"])
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("h4", {
      class: "textFormat",
      style: _normalizeStyle({ color: _ctx.setOverviewColor }),
      innerHTML: _ctx.formatText(_ctx.template.overview)
    }, null, 12, _hoisted_5),
    (_ctx.template.displayFields)
      ? (_openBlock(), _createBlock(_component_DisplayFields, {
          key: 3,
          displayFields: _ctx.template.displayFields,
          theme: _ctx.templateTheme
        }, null, 8, ["displayFields", "theme"]))
      : _createCommentVNode("", true),
    (_ctx.template.inputFields)
      ? (_openBlock(), _createBlock(_component_Inputs, {
          key: 4,
          onInputUpdated: _ctx.inputsUpdated,
          inputs: _ctx.template.inputFields,
          answers: _ctx.inputData,
          "is-Disabled": _ctx.isDisabled
        }, null, 8, ["onInputUpdated", "inputs", "answers", "is-Disabled"]))
      : _createCommentVNode("", true),
    _createElementVNode("p", {
      class: "textFormat",
      style: _normalizeStyle({ color: _ctx.setConclusionColor }),
      innerHTML: _ctx.formatText(_ctx.template.conclusion)
    }, null, 12, _hoisted_6),
    (_ctx.template.buttons && !_ctx.isSilentAuth)
      ? (_openBlock(), _createBlock(_component_Buttons, {
          key: 5,
          onButtonClicked: _ctx.buttonClicked,
          buttons: _ctx.template.buttons,
          theme: _ctx.templateTheme,
          isDisabled: _ctx.isDisabled
        }, null, 8, ["onButtonClicked", "buttons", "theme", "isDisabled"]))
      : _createCommentVNode("", true),
    (_ctx.template.footerLogoURIs)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
          _createVNode(_component_FooterLogos, {
            logos: _ctx.template.footerLogoURIs
          }, null, 8, ["logos"])
        ]))
      : _createCommentVNode("", true)
  ]))
}